module.exports = __webpack_public_path__ + "static/media/image.70014b56.png";